import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import PageTitle from '../../../../components/partials/PageTitle';
import ReportFilter from './ReportFilter';
import { CSVLink } from 'react-csv';
import excel from "../../../../assets/images/img-icons/excel.png";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import { getCustomerPolicyExpiry } from '../../../../redux/slice/report/reportSlice';
import { useReactToPrint } from 'react-to-print';
import { useNavigate } from 'react-router-dom';

const CustomerPolicyExpiry = () => {

    const [filterData, setFilterData] = useState();
    const [filteredItem, setFilteredItem] = useState(false)

    const CCPdfRef = useRef()

    const { user } = useSelector((state) => state.auth);
    const {customerOverviewData} = useSelector((state) => state.report);
    const { user_permissions } = useSelector((state) => state?.auth?.user);

    const navigate = useNavigate();
    const dispatch = useDispatch() 

    const breadcrumb = {
        from: {
          title: "Policy Report",
          link: "/admin/reports/policy-report",
        },
        current: {
          title: "Policy Expiry/Renewal",
          link: null,
        },
    };

    const processedData = customerOverviewData?.map(row => {
      const fullName = `${row.customerFirstName} ${row.customerLastName}`;
      const agent = `${row.agentFirstName} ${row.agentLastName}`;
      const statusValue = row.status;
      let statusLabel = '';
  
      switch (statusValue) {
        case "1":
          statusLabel = 'pending';
          break;
        case "2":
          statusLabel = 'active';
          break;
        case "3":
          statusLabel = 'matured';
          break;
        default:
          statusLabel = 'unknown';
      }
  
      return { ...row, full_name: fullName, agent, status: statusLabel }; // Modify status property while keeping the rest
    }); 

    const headers = [
      { label: 'Customer ID', key: 'customerId' },
      { label: 'Customer Name', key: 'full_name' },
      { label: 'Policy', key: 'policyName' },
      { label: 'Effective Date', key: 'effectiveDate' },
      { label: 'End Date', key: 'endDate' },
      { label: 'Renewal Date', key: 'endDate' },
      { label: 'Status', key: 'status' },
      { label: 'Agent', key: 'agent' },
      { label: 'Office', key: 'office_name' },
    ];

    // print table to pdf
  const generatePDF = useReactToPrint({
    content: () => CCPdfRef.current,
    documentTitle: "Customer Policy Expiry",
  });

  useEffect(() => {
    if (filteredItem) {
      if (filterData.office_id === '') {
        const updatedFilterData = {
          ...filterData,
          office_id: user?.user?.office_id
        };
        dispatch(getCustomerPolicyExpiry(updatedFilterData));
      }else{
        dispatch(getCustomerPolicyExpiry(filterData));
      }
    }
  }, [dispatch, filterData, filteredItem, user?.user?.office_id])

  useEffect(() => {
    if (!user_permissions?.some(permission => permission.name === 'customer report module') || !user_permissions?.some(permission => permission.name === 'customer policy expiry-renewal date report')) {
      navigate('/admin/dashboard')
    }
  }, [navigate, user_permissions])
  return (
    <>
        {/* page title */}
        <PageTitle title='Policy Expiry/Renewal' breadcrumb={breadcrumb} />
        {/* end page title */} 
        <div className='row card p-1' style={{ margin: "auto 1px" }}>
          <ReportFilter 
            page={'policyExpiry'}
            setFilterData={setFilterData}
            setFilteredItem={setFilteredItem}
            filteredItem={filteredItem}
          />
        {customerOverviewData && <div className="row mb-3">
          <>
              <div className='d-flex justify-content-end align-items-center'>
                  <div className=' d-flex align-items-center border '>
                  <span
                      className='bg-info me-2 text-white'
                      style={{ padding: "3px" }}
                  >
                      Export to
                  </span>

                  <span
                      href='#'
                      id='btnExport'
                      className='me-1 cursor-p'
                      title='Export to Pdf'
                      onClick={generatePDF}
                  >
                      <img
                      src={pdf}
                      alt='export-pdf'
                      style={{ height: "25px" }}
                      />
                  </span>
                  {customerOverviewData ? (
                      <CSVLink
                      data={processedData}
                      headers={headers}
                      style={{ fontWeight: "bolder", cursor: "pointer" }}
                      filename='Customer Policy Expiry'
                      >
                      <span
                          href='#'
                          id='btnExport'
                          className='mr-1'
                          title='Export to Excel'
                      >
                          <img
                          src={excel}
                          alt='export-excel'
                          style={{ height: "25px", marginRight: "5px" }}
                          />
                      </span>
                      </CSVLink>
                  ) : null}
                  </div>
              </div>
              <div className='table-responsive'>
              <table className='table table-centered table-striped nowrap w-100 no-footer' ref={CCPdfRef}>
                      <thead>
                          <tr>
                              <th
                                  className='sorting'
                                  tabIndex='0'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "100.8px" }}
                                  aria-label='Email: activate to sort column ascending'
                              >
                                Customer Id
                              </th>
                              <th
                                  className='sorting'
                                  tabIndex='0'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "150.8px" }}
                                  aria-label='Customer: activate to sort column ascending'
                              >
                                Customer Name
                              </th>
                              <th
                                  className='sorting'
                                  tabIndex='0'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "134.8px" }}
                                  aria-label='Phone: activate to sort column ascending'
                              >
                                Policy
                              </th>
                              <th
                                  className='sorting'
                                  tabIndex='0'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "120.8px" }}
                                  aria-label='Status: activate to sort column ascending'
                              >
                                Effective Date
                              </th>
                              <th
                                  className='sorting'
                                  tabIndex='0'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "120.8px" }}
                                  aria-label='Status: activate to sort column ascending'
                              >
                                End Date
                              </th>
                              <th
                                  className='sorting'
                                  tabIndex='0'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "120.8px" }}
                                  aria-label='Status: activate to sort column ascending'
                              >
                                Renewal Date
                              </th>
                              <th
                                  className='sorting'
                                  tabIndex='0'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "120.8px" }}
                                  aria-label='Status: activate to sort column ascending'
                              >
                                Status
                              </th>
                              <th
                                  className='sorting'
                                  tabIndex='0'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "120.8px" }}
                                  aria-label='Status: activate to sort column ascending'
                              >
                                Agent
                              </th>
                              <th
                                  className='sorting'
                                  tabIndex='0'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "120.8px" }}
                                  aria-label='Status: activate to sort column ascending'
                              >
                                Office
                              </th>
                          </tr>
                      </thead>
                      {customerOverviewData?.length ? <tbody>
                          {customerOverviewData?.map((item, i) => ( 
                              <tr key={i}>
                                  <td className='text-dark'>
                                      {item?.customerId}
                                  </td>
                                  <td className='table-user'>
                                      <span
                                          className='text-body fw-semibold'
                                      >
                                          {item?.customerFirstName} {item?.customerLastName}
                                      </span>
                                  </td>                                      
                                  <td className='table-user'>
                                    {item?.policyName}
                                  </td>                                                                                                               
                                  <td className='table-user'>
                                    {item?.effectiveDate}
                                  </td>        
                                  <td>{item?.endDate}</td>                              
                                  <td>{item?.endDate}</td>                              
                                  <td>
                                    {item?.status === "1" && "Pending"}
                                    {item?.status === "2" && "Active"}
                                    {item?.status === "3" && "Matured"}
                                  </td>                              
                                  <td>{item?.agentFirstName} {item?.agentLastName}</td>
                                  <td>{item?.office_name}</td>
                              </tr>
                          ))}
                      </tbody> : null}
                  </table>
                  {customerOverviewData?.length < 1 ? (
                      <h5 className='alert alert-info'>No result found!</h5>
                  ) : null}
              </div>
          </>
        </div>}
      </div>    
    </>
  )
}

export default CustomerPolicyExpiry